module.exports = __webpack_public_path__ + "static/media/Reset.98af0584.svg";